"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment["PROD"] = "PROD";
    Environment["STAGING"] = "STAGING";
    Environment["DEV"] = "DEV";
})(Environment || (exports.Environment = Environment = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW51bXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc3BsaXQvZW51bXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxXQUlYO0FBSkQsV0FBWSxXQUFXO0lBQ25CLDRCQUFhLENBQUE7SUFDYixrQ0FBbUIsQ0FBQTtJQUNuQiwwQkFBVyxDQUFBO0FBQ2YsQ0FBQyxFQUpXLFdBQVcsMkJBQVgsV0FBVyxRQUl0QiJ9


// WEBPACK FOOTER //
// ../../../src/split/enums.ts